import { render, staticRenderFns } from "./px-modal.vue?vue&type=template&id=152226c2&scoped=true&"
import script from "./px-modal.vue?vue&type=script&lang=ts&"
export * from "./px-modal.vue?vue&type=script&lang=ts&"
import style0 from "./px-modal.vue?vue&type=style&index=0&id=152226c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152226c2",
  null
  
)

export default component.exports